import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANGUAGE_CODE, isLanguageCode } from '@nk/localization-lib';

@Pipe({
  name: 'percentage',
  standalone: true,
})
export class PercentagePipe implements PipeTransform {
  private _decimalPipe: DecimalPipe;

  constructor(private _translateService: TranslateService) {
    const localeId = this._translateService.currentLang;
    const locale = isLanguageCode(localeId) ? localeId : DEFAULT_LANGUAGE_CODE;
    this._decimalPipe = new DecimalPipe(locale);
  }

  public transform(value: number | null, digitsInfo = '.1-1'): string {
    if (value === null) {
      return '-';
    }
    if (typeof value !== 'number') {
      return value;
    }
    const percentage = this._decimalPipe.transform(100 * value, digitsInfo);
    return `${percentage}%`;
  }
}
